// extracted by mini-css-extract-plugin
module.exports = {"groupnav":"groupnav_groupnav__1Vi99"};